import { render, staticRenderFns } from "./specialBrands.vue?vue&type=template&id=96404048&scoped=true&"
import script from "./specialBrands.vue?vue&type=script&lang=js&"
export * from "./specialBrands.vue?vue&type=script&lang=js&"
import style0 from "./specialBrands.vue?vue&type=style&index=0&id=96404048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96404048",
  null
  
)

export default component.exports